export enum FeatureName {
  None = 'None',
  CaptionV2 = 'CaptionV2',
}

class LocalStorageFeatureToggle {
  set(featureName: `${FeatureName}`, value: boolean) {
    this.validateFeatureName(featureName)
    if (value) {
      window.localStorage.setItem(featureName, '1')
    } else {
      window.localStorage.removeItem(featureName)
    }
  }

  get(featureName: `${FeatureName}`) {
    return !!window.localStorage.getItem(featureName)
  }

  private validateFeatureName(featureName: string) {
    if (!Object.values(FeatureName).includes(featureName as FeatureName)) {
      throw new Error(`Invalid feature name: ${featureName}`)
    }
  }
}

export const localStorageFeatureToggle = new LocalStorageFeatureToggle()
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).localStorageFeatureToggle = localStorageFeatureToggle
